export default "__VITE_ASSET__266d110f__"